import { createSlice } from '@reduxjs/toolkit';
import { getAllAccountSettings, getGeneralSettings } from './thunk';

export const initialState = {
  settings: {},
  accountSettings: JSON.parse(localStorage.getItem('accountSettings')) || {},
  isLoading: false,
  isError: false,
  error: {},
};

const generalSettingsSlice = createSlice({
  name: 'GeneralSettings',
  initialState,
  reducers: {
    setAccountSettings: (state, action) => {
      state.accountSettings = action.payload;
      localStorage.setItem('accountSettings', JSON.stringify(action.payload));
    },
    clearAccountSettings: (state) => {
      state.accountSettings = {};
      localStorage.removeItem('accountSettings');
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getGeneralSettings.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getGeneralSettings.fulfilled, (state, action) => {
      state.isLoading = false;
      state.settings = action.payload;
    });
    builder.addCase(getGeneralSettings.rejected, (state, action) => {
      state.isError = true;
      state.error = action.payload || null;
      console.log(action);
    });

    builder.addCase(getAllAccountSettings.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getAllAccountSettings.fulfilled, (state, action) => {
      state.isLoading = false;
      state.accountSettings = action.payload;
      localStorage.setItem('accountSettings', JSON.stringify(action.payload));
    });
    builder.addCase(getAllAccountSettings.rejected, (state, action) => {
      state.isError = true;
      state.error = action.payload || null;
    });
  },
});

export const { setAccountSettings, clearAccountSettings } =
  generalSettingsSlice.actions;
export default generalSettingsSlice.reducer;
